import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useState } from 'react';
// import { useSelector } from 'react-redux';
// import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import { CSVLink } from 'react-csv';
// import { jsPDF } from 'jspdf';
// import moment from 'moment';

import useUserTimeZone, { getTimeZoneAbbreviation } from '../../../hooks/useUserTimeZone';

const DownloadMenuBusiness = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { formatDateTime } = useUserTimeZone();

  // const TITLE_NAME = 'Product Category';
  const FILE_NAME = 'SafalEvent-Type';

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async () => {
    setAnchorEl(null);
  };

  const handleDownload = async (format) => {
    // await createLog('company', `Exported companies list in ${format} format.`, 'N/A', 'N/A');
    setTimeout(() => {
      toast.success('Download successful.');
    }, 1000);
  };

  const sortData = data?.map((e, index) => ({
    no: index + 1,
    name: e?.name,
    createdAt: `${formatDateTime(e?.createdAt)} ${getTimeZoneAbbreviation()}`,
    status: e?.status,
  }));

  const headers = [
    { label: 'No.', key: 'no' },
    { label: 'Name', key: 'name' },
    { label: 'Created At', key: 'createdAt' },
    { label: 'Status', key: 'status' },
  ];

  return (
    <div>
      <Tooltip title="Download">
        <IconButton
          sx={{
            color: '#FFFFFF',
            backgroundColor: '#027c34',
            '&:hover': { backgroundColor: '#027c34', color: '#FFFFFF' },
          }}
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <FileDownloadIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{
          marginTop: '6px',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <CSVLink
          data={sortData}
          headers={headers}
          filename={FILE_NAME}
          target="_blank"
          style={{ textDecoration: 'none', color: 'black' }}
          onClick={() => handleDownload('CSV')}
        >
          <MenuItem onClick={handleClose}>Export as CSV</MenuItem>
        </CSVLink>
        <CSVLink
          separator={'\t'}
          data={sortData}
          headers={headers}
          filename={`${FILE_NAME}.dnl`}
          target="_blank"
          style={{ textDecoration: 'none', color: 'black' }}
          onClick={() => handleDownload('DNL')}
        >
          <MenuItem onClick={handleClose}>Export as DNL</MenuItem>
        </CSVLink>
        <CSVLink
          data={sortData}
          headers={headers}
          filename={`${FILE_NAME}.txt`}
          target="_blank"
          style={{ textDecoration: 'none', color: 'black' }}
          onClick={() => handleDownload('TXT')}
        >
          <MenuItem onClick={handleClose}>Export as TXT</MenuItem>
        </CSVLink>
        {/* <CSVLink
          data={sortData}
          headers={headers}
          filename={'Master-Companies.pdf'}
          target="_blank"
          style={{ textDecoration: 'none', color: 'black' }}
          onClick={handleExportPDF}
        >
          <MenuItem onClick={handleClose}>Export as PDF</MenuItem>
        </CSVLink> */}
      </Menu>
    </div>
  );
};

export default DownloadMenuBusiness;
